import styled, { css } from "styled-components";

export const Backdrop = styled.div<{ visible?: boolean }>`
   width: 100vw;
   height: 100vh;
   background-color: rgba(0, 0, 0, 0.52);
   position: fixed;
   display: flex;
   align-items: center;
   justify-content: center;
   top: 0;
   left: 0;
   opacity: 0;
   visibility: hidden;
   z-index: 100;
   transition: opacity 250ms ease-in-out 100ms, visibility 250ms ease-in-out,
      visibility 250ms ease-in-out;

   ${({ visible }) =>
      visible &&
      css`
         opacity: 1;
         visibility: visible;
      `}
`;
